import React, { PureComponent } from "react";
import classes from "./SixthBlock.module.css";
import cn from "clsx";
import Typography from "../ui-kit/Typography";
import Container from "../ui-kit/Container";
import Button from "../ui-kit/Button";
import { trackCustomEvent } from "gatsby-plugin-google-analytics";

interface BlockStepProps {
  stepNumber: number;
  stepText: string;
}

const BlockStep: React.FC<BlockStepProps> = (props: BlockStepProps) => {
  const { stepNumber, stepText } = props;

  const [isVisible, setVisible] = React.useState(false);
  const domRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(entry.isIntersecting);
        }
      });
    });
    if (!domRef.current) {
      throw new Error("domRef is undefined");
    }
    observer.observe(domRef.current);
    const element = domRef.current;
    return () => observer.unobserve(element);
  }, []);

  return (
    <div
      className={cn(classes.step, {
        [classes.active]: isVisible,
      })}
      ref={domRef}
    >
      <span className={cn(classes.stepNumber)}>{stepNumber}</span>
      <Typography
        variant="h3"
        component="span"
        color="primary"
        className={cn(classes.stepText)}
      >
        <b>{stepText}</b>
      </Typography>
    </div>
  );
};

interface SixthBlockProps {}

class SixthBlock extends PureComponent<SixthBlockProps> {
  render(): React.ReactNode {
    return (
      <Container>
        <div className={cn(classes.textContainer)}>
          <Typography gutterBottom color="primary" component="h3" variant="h2">
            <b>Помогать просто</b>
          </Typography>
          <Typography gutterBottom color="primary" isSemiTransperent>
            <b>
              Сделать финансовое пожертвование в фонд или приют — самый надежный
              способ помочь. Там отлично знают, что действительно необходимо их
              подопечным в данный момент. Каждый рубль важен, ведь именно он
              может спасти чью-то жизнь.
            </b>
          </Typography>
          <Typography gutterBottom color="primary" isSemiTransperent>
            <b>
              Но на самом деле, способов поддержки гораздо больше! Например, вы
              можете дать вторую жизнь старым вещам или применить с пользой свои
              таланты.
            </b>
          </Typography>
        </div>
        <div>
          <BlockStep
            stepNumber={1}
            stepText="Питомцам в приюте всегда необходим корм, теплые вещи, коврики и одеяла для подстилок."
          />
          <BlockStep
            stepNumber={2}
            stepText="Возможно, у вас найдутся для них поводки, шлейки и ошейники."
          />
          <BlockStep
            stepNumber={3}
            stepText="В приютах не бывает лишних лекарств."
          />
          <BlockStep
            stepNumber={4}
            stepText="Распространяйте информацию в соцсетях — ставьте, лайки, делайте репосты"
          />
          <BlockStep
            stepNumber={5}
            stepText="Если у вас есть машина, помогите в перевозке животных."
          />
          <BlockStep
            stepNumber={6}
            stepText="Если вы умеете снимать, помогите сделать фото- или видеопрофайл, который поможет найти новых хозяев."
          />
          <BlockStep
            stepNumber={7}
            stepText="Станьте волонтером — всем подопечным приютов и фондов необходимо человеческое общение и регулярный выгул."
          />
          <BlockStep
            stepNumber={8}
            stepText="Помогите с ремонтом вольеров и уборкой территории."
          />
          <BlockStep
            stepNumber={9}
            stepText="Участвуйте в организации благотворительных мероприятий или предложите совместный проект."
          />
          <BlockStep
            stepNumber={10}
            stepText="Оформите опекунство над одним или несколькими животными. "
          />
          <BlockStep
            stepNumber={11}
            stepText="Подпишитесь на регулярные пожертвования."
          />
          <BlockStep
            stepNumber={12}
            stepText="Поделитесь информацией о нашей акции «Двери не закрываются» в сторис или посте — так больше людей узнает, в чем нуждаются фонды и приюты для бездомных животных. Помогать просто!"
          />
        </div>
        <div className={cn(classes.buttons)}>
          <Button
            onClick={this.handleHelpClick}
            href="https://fundvet.city/help-us"
            color="secondary"
          >
            <Typography variant="h3" component="span" color="inverted">
              Помочь
            </Typography>
          </Button>
          <Button
            onClick={this.handleBecomeOwnerClick}
            href="https://fundvet.city/stat-opekunom"
            color="secondary"
          >
            <Typography variant="h3" component="span" color="inverted">
              Стать опекуном
            </Typography>
          </Button>
        </div>
      </Container>
    );
  }

  private handleHelpClick = () => {
    trackCustomEvent({
      category: "button",
      action: "g_m_help",
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ym(53234908, "reachGoal", "y_m_help");
  };

  private handleBecomeOwnerClick = () => {
    trackCustomEvent({
      category: "button",
      action: "g_m_adopt",
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.ym(53234908, "reachGoal", "y_m_adopt");
  };
}

export default SixthBlock;
